import { useEffect, useState, useCallback } from 'react';
import { RemoteParticipant } from 'twilio-video';
import useDominantSpeaker from '../useDominantSpeaker/useDominantSpeaker';
import useVideoContext from '../useVideoContext/useVideoContext';
import * as PatientApis from '../../apis/patient';

export default function useParticipantsList(participants:any, params:any) {
  const { room } = useVideoContext();
  const [participantList, setParticipantList] = useState([])
  useEffect(() => {
    try{
      //fetchParticipants()
      PatientApis.getParticipants(params.therapistRoom).then(result => {
        setParticipantList(result.data)
      }).catch(e => {
        console.log(e)
      })
    }catch (e){
      console.log('error')
    }
  }, [participants]);



  return participantList;
}
